import React from 'react';
import PropTypes from 'prop-types';

import RestoreIcon from '@mui/icons-material/Restore';
import { Collapse, TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import BloodTestRowDetails from './BloodTestRowDetails';

import table from '../../../../commonStyles/tables.module.css';
import tableRow from './bloodTest.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const BloodTestRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    toggleDropdown,
    openId,
    isAuditable,
    onSearchAuditItems
}) => {
    const onToggleDropdown = () => toggleDropdown(openId === row.id ? '' : row.id);

    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={`${table.tableRowStripes} ${table.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{formatDate(row.eventDate)}</TableCell>
                <TableCell>{row.testType}</TableCell>
                <TableCell>
                    <div>
                        <span className={tableRow.alignRow}>{row.testValue}</span>
                        {isAuditable && (
                            <span className={table.auditIcon}>
                                <RestoreIcon
                                    onClick={(e) =>
                                        onSearchAuditItems(
                                            e,
                                            row.id,
                                            'Blood Test',
                                            'Test Value',
                                            'blood-test'
                                        )
                                    }
                                />
                            </span>
                        )}
                    </div>
                </TableCell>
                <TableCell>{row.testValueType}</TableCell>
                <TableCell>{row.testResult}</TableCell>
                <TableCell align="right">
                    <OnEditIcon onEdit={(e) => onEdit(e, row)} active={!isDisabled} />
                </TableCell>
                <TableCell align="right">
                    <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={styles} colSpan={7}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <BloodTestRowDetails row={row} onClose={onToggleDropdown} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

BloodTestRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    isAuditable: PropTypes.bool,
    onSearchAuditItems: PropTypes.func
};

export default BloodTestRow;
